'use strict';

import { CoreRepository } from '../CoreRepository';
import { AgencyAgentContract } from '../../Entities/Agency/AgencyAgentContract';
import { AgencyAgentContractCollection } from '../../Collections/Agency/AgencyAgentContractCollection';

export class AgencyAgentContractRepository extends CoreRepository {
  public processAgencyAgentContractChunk(
    userId: number,
    agencyId: number,
    reportId: number,
    options: object = null
  ) {
    if (!options) {
      options = {};
    }

    return this.webAPI
      .processAgencyAgentContractChunk(userId, agencyId, reportId, options)
      .then((response) => {
        return response;
      });
  }

  public processAgencyAgentContractRtsFromUpload(
    userId: number,
    agencyId: number,
    reportId: number,
    options: object = null
  ) {
    if (!options) {
      options = {};
    }

    return this.webAPI
      .processAgencyAgentContractRtsFromUpload(userId, agencyId, reportId, options)
      .then((response) => {
        return response;
      });
  }

  public processAgencyAgentContractStatesFromUpload(
    userId: number,
    agencyId: number,
    reportId: number,
    options: object = null
  ) {
    if (!options) {
      options = {};
    }

    return this.webAPI
      .processAgencyAgentContractStatesFromUpload(userId, agencyId, reportId, options)
      .then((response) => {
        return response;
      });
  }

  public processAgencyAgentContractProductsFromUpload(
    userId: number,
    agencyId: number,
    reportId: number,
    options: object = null
  ) {
    if (!options) {
      options = {};
    }

    return this.webAPI
      .processAgencyAgentContractProductsFromUpload(userId, agencyId, reportId, options)
      .then((response) => {
        return response;
      });
  }

  public processAgencyAgentContractWritingNumbersFromUpload(
    userId: number,
    agencyId: number,
    reportId: number,
    options: object = null
  ) {
    if (!options) {
      options = {};
    }

    return this.webAPI
      .processAgencyAgentContractWritingNumbersFromUpload(userId, agencyId, reportId, options)
      .then((response) => {
        return response;
      });
  }

  public findAgencyAgentContractMissingFromUpload(
    userId: number,
    agencyId: number,
    reportId: number,
    options: object = {},
    criteria: object = null
  ) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI
      .findAgencyAgentContractMissingFromUpload(userId, agencyId, reportId, options)
      .then((response) => {
        return response;
      });
  }

  /*
    public getAgencyAgentContracts(options: object = {}, criteria: object = null){
        if( !options )
        {
        options = {};
        }

        if( criteria )
        {
        options['criteria'] = criteria;
        }

        return this.webAPI.get(options)
        .then( response => {
            let collection = new AgencyAgentContractCollection();

            response.data.forEach(collectionItemData => {
            let collectionItem = new AgencyAgentContract();
                collectionItem.hydrate(collectionItemData);

            collection.addItem(collectionItem);
            });

            collection.setOffset(response.offset);
            collection.setLimit(response.limit);
            collection.setTotal(response.total);

            return collection;
        });

    }
    */

  /*
    public getAgencyAgentContract(options: object = null){
        if( !options )
        {
        options = {};
        }

        return this.webAPI.getAgencyAgentContract(options)
        .then( response => {
            if( !response )
            {
            return false;
            }

            let AgencyAgentContract = new AgencyAgentContract();
            AgencyAgentContract.hydrate(response);

            return AgencyAgentContract;
        });
    }

    public createAgencyAgentContract(payload: object = {}){  
    return this.webAPI.createAgencyAgentContract(payload)
      .then( response => {
        let AgencyAgentContract = new AgencyAgentContract();
        AgencyAgentContract.hydrate(response);

        return AgencyAgentContract;
      });
    }

    public updateAgencyAgentContract(payload: object = {}){  
        return this.webAPI.updateAgencyAgentContract(payload)
        .then( response => {
            let AgencyAgentContract = new AgencyAgentContract();
            AgencyAgentContract.hydrate(response);

            return AgencyAgentContract;
        });
    }

    public removeAgencyAgentContract( ){
        return this.webAPI.removeAgencyAgentContract()
        .then( response => {
            return response;
        });
    }
    */
}
